import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { EventContext } from "Components";
import { Layout, BodySection, Container } from "../Layout";

export const PreCampaign = () => {
  const { event } = useContext(EventContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  let headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  let footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;

  return (
    <Layout
      // header
      headerShowLogo={false}
      headerSecondaryText={event?.preCampaign?.header}
      // main
      noPadding
      // add-ons
      noAddons
      // footer
      footerShowLogo
      footerLogo={headerLogo}
      footerLogoLink={event.logos.header.link}
      footerShowText
      footerPrivacyPolicy={event?.footer}
    >
      <StyledBodySection>
        <Container>
          <p>{ReactHtmlParser(event.preCampaign.body)}</p>
        </Container>
      </StyledBodySection>
    </Layout>
  );
};

const StyledBodySection = styled(BodySection)`
  background-color: unset;
  color: #102b4e;
  padding: 15px;
  display: flex;
  height: 100%;
  align-items: center;
`;
